import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";
import { CreateGameNameAssistantResponse } from "../type";

export const createGameNameAssistant = async () => {
  const fn = httpsCallable(functions, "createGameNameTranslationAssistant");
  const { data: responseData } = await fn();
  return responseData as CreateGameNameAssistantResponse;
};
